import React from "react";
import pana from "../assets/pana.png";
import { Link } from "react-router-dom";

function Welcome() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 flex flex-col justify-center items-center px-4 py-8">
      {/* Main Welcome Card */}
      <div className="w-full max-w-md sm:max-w-lg lg:max-w-xl bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 hover:scale-105">
        
        {/* Header Section with Image */}
        <div className="bg-gradient-to-r from-primary100 to-emerald-600 px-6 py-8 text-center">
          <div className="flex justify-center mb-4">
            <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 bg-white rounded-full p-4 shadow-lg">
              <img 
                src={pana} 
                alt="Promise Healthcare" 
                className="w-full h-full object-contain"
              />
            </div>
          </div>
          <h1 className="text-white text-2xl sm:text-3xl lg:text-4xl font-bold mb-2">
            Welcome to Promise
          </h1>
          <div className="w-16 h-1 bg-white mx-auto rounded-full"></div>
        </div>

        {/* Content Section */}
        <div className="px-6 py-8">
          <p className="text-gray-600 text-sm sm:text-base lg:text-lg leading-relaxed text-center mb-8">
            We are committed to providing exceptional healthcare services and
            personalized care to our patients. Your health is our top priority,
            and we strive to make your experience with us comfortable and healing.
            We look forward to serving you and being a part of your journey to better health.
          </p>

          {/* Action Buttons */}
          <div className="space-y-4">
            <Link to="/register" className="block">
              <button className="w-full py-4 bg-primary100 hover:bg-emerald-700 rounded-xl text-white text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl">
                Get Started - Register
              </button>
            </Link>
            
            <Link to="/login" className="block">
              <button className="w-full py-4 bg-white hover:bg-gray-50 rounded-xl text-primary100 text-lg font-semibold border-2 border-primary100 transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg">
                Already have an account? Login
              </button>
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="mt-8 pt-6 border-t border-gray-100">
            <div className="flex justify-center items-center space-x-6 text-xs sm:text-sm text-gray-500">
              <div className="flex items-center space-x-1">
                <div className="w-2 h-2 bg-primary100 rounded-full"></div>
                <span>Secure</span>
              </div>
              <div className="flex items-center space-x-1">
                <div className="w-2 h-2 bg-primary100 rounded-full"></div>
                <span>Trusted</span>
              </div>
              <div className="flex items-center space-x-1">
                <div className="w-2 h-2 bg-primary100 rounded-full"></div>
                <span>Professional</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Text */}
      <p className="mt-6 text-center text-gray-500 text-sm max-w-md">
        Your health journey starts here. Join thousands of patients who trust Promise for their healthcare needs.
      </p>
    </div>
  );
}

export default Welcome;
